/**
 * @module doesActionableMessageEnabledByTenant
 */

import hasClientConfiguration from './hasClientConfiguration';
import getClientConfigurationFromStore from '../selectors/getClientConfigurationFromStore';

/**
 * @function
 * To check whether the Actionable Message is enabled by the tenant
 * @returns whether the Actionable Message is supported
 */

const doesActionableMessageEnabledByTenant = (): boolean => {
    let isEnabled = false;
    if (hasClientConfiguration()) {
        const cache = getClientConfigurationFromStore();
        if (cache?.data?.organizationConfigs?.SmtpActionableMessagesEnabled) {
            isEnabled = true;
        }
    }
    return isEnabled;
};

export default doesActionableMessageEnabledByTenant;
